import { render } from "./benefitComponent.vue?vue&type=template&id=aedee2a2&scoped=true"
const script = {}

import "./benefitComponent.vue?vue&type=style&index=0&id=aedee2a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Proyectos Vue.js\\version-produccion-iquela\\Dashboard_usuarios\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aedee2a2"]])

export default __exports__